import React from "react";
import { Column } from "primereact/column";
import {
  DataTable,
  DataTableExpandedRows,
  DataTableRowToggleEvent,
} from "primereact/datatable";
import ActionButton from "../../../components/controls/ActionButton";
import { convertToTwoDecimals } from "../../../shared/utility";
import { lastNine } from "../employeeProductionHelpers";
import {
  ProductionRecipeItem,
  ReceivingItem,
} from "../employeeProductionTypes";

type Props = {
  items: ProductionRecipeItem[];
  expandedRows: Record<string, boolean> | ProductionRecipeItem[] | null;
  onExpandedRowsChange: (
    rows: Record<string, boolean> | ProductionRecipeItem[] | null,
  ) => void;
  onItemSelected: (item: ReceivingItem) => void;
};

export function ProductionRecipeTable({
  items,
  expandedRows,
  onExpandedRowsChange,
  onItemSelected,
}: Props) {
  const rowExpansionTemplate = (recipe: ProductionRecipeItem) => (
    <div className="p-0">
      <DataTable
        value={recipe.receivingItems}
        tableClassName="manufacture-recipe-items-children-table min-w-full divide-y divide-gray-300 bg-white"
        cellClassName={() => "border-1-bottom-gray bg-gray-100 py-2"}
      >
        <Column
          header="Barcode (Last 9)"
          body={(item: ReceivingItem) => lastNine(item.barcode)}
        />
        <Column
          header="Amount Used"
          body={(item: ReceivingItem) => (
            <span>
              {convertToTwoDecimals(item.ingredient_amount_used)}{" "}
              {item.unit_of_measure ?? ""}
            </span>
          )}
        />
        <Column
          header="Actions"
          body={(item: ReceivingItem) => (
            <ActionButton onClick={() => onItemSelected(item)}>
              Edit
            </ActionButton>
          )}
          style={{ width: "5rem" }}
        />
      </DataTable>
    </div>
  );

  if (items.length === 0) return null;

  return (
    <div className="mt-4">
      <DataTable
        value={items}
        expandedRows={expandedRows ?? undefined}
        onRowToggle={(event: DataTableRowToggleEvent) =>
          onExpandedRowsChange(
            event.data as ProductionRecipeItem[] | DataTableExpandedRows,
          )
        }
        rowExpansionTemplate={rowExpansionTemplate}
        dataKey="id"
        className="p-datatable-sm"
      >
        <Column field="bom_name" header="BOM Name" />
        <Column
          header="Total in Use"
          body={(recipe: ProductionRecipeItem) => (
            <span>
              {recipe.amount_in_use ?? 0} {recipe.unit_of_measure_label ?? ""}
            </span>
          )}
        />
        <Column
          expander={(recipe: ProductionRecipeItem) =>
            recipe.receivingItems.length > 0
          }
          style={{ width: "5rem" }}
        />
      </DataTable>
    </div>
  );
}
